import { MainRoutes } from "../models/routes/mainRoutes";

export const routes: MainRoutes = {
    ordering: { route: "/", path: "/" },
    deliveryOptions: { route: "delivery-options", path: "/delivery-options" },
    recommendedServices: { route: "recommended-services", path: "/recommended-services" },
    booking: { route: "booking", path: "/booking" },
    verification: { route: "verification", path: "/verification" },
    orderConfirmation: { route: "order-confirmation", path: "/order-confirmation" },
    login: { route: "login", path: "/login" },
    signUp: { route: "registration", path: "/registration" },
    confirmEmail: { route: "confirm-email", path: "/confirm-email" },
    forgotPassword: { route: "forgot-password", path: "/forgot-password" },
    resetPassword: { route: "reset-password", path: "/reset-password" },
    // Side nav bar
    profile: { route: "profile", path: "/profile" },
    myOrders: { route: "my-orders", path: "/my-orders" },
    mySuggestions: { route: "my-suggestions", path: "/my-suggestions" },
    addressBook: { route: "address-book", path: "/address-book" },
    support: { route: "support", path: "/support" },
    tariffLoader: { route: "tariff-loader", path: "/tariff-loader" },
    exchangeRates: { route: "exchange-rates", path: "/exchange-rates" },
    notifications: { route: "notifications", path: "/notifications" },
    adminPanel: { route: "admin-panel", path: "/admin-panel" },
};
